<template>
  <tfoot v-if="rows.length > 0">
    <tr style="background-color: #f2f2f28e">
      <td class="text-center p-3">
        <strong style="text-align: center">
          {{
            numberPages > 1
              ? $t('common_words.sub_total')
              : $t('common_words.totalized')
          }}
        </strong>
      </td>
      <td
        v-for="(typeReturn, index) in cellNames"
        :key="index"
        style="text-align: center"
      >
        {{ getFormatNumber(fieldSubTotals(index, typeReturn), index) }}
      </td>
    </tr>
    <tr v-if="numberPages > 1">
      <td>
        <strong style="text-align: center">{{
          $t('common_words.totalized')
        }}</strong>
      </td>
      <td
        v-for="(typeReturn, index) in cellNames"
        :key="index"
        style="text-align: center"
      >
        {{ getFormatNumber(fieldSubTotals(index, typeReturn), index) }}
      </td>
    </tr>
  </tfoot>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util';
import Formatter from 'src/class/Formatter';

export default {
  name: 'tfoot-profile-cluster',
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    totals: {
      type: Array | Object,
    },
    numberPages: {
      type: Number,
    },
    cellNames: {
      type: Object,
    },
    reportType: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    getFormatNumber(value, index) {
      if (Number(value) === 0) return '';

      switch (index) {
        case 'fingers_number':
          return Formatter.formatNumber(value, 0);
        case 'hands_number_avg':
          return Math.floor(value);

        default:
          return Formatter.formatNumber(value, 2);
      }
    },

    fieldSubTotals(index, returnType) {
      let result = [];
      try {
        result = this.rows.map((row) => row[index]);
      } catch (error) {}

      if (Number(this.reportType) === 0) {
        result = result.reduce((acc, data) => acc.concat(data));
      }

      if (
        Number(this.reportType) === 0 &&
        (index === 'ratio' || index === 'merma')
      ) {
        let sum = this.rows.map((row) => row['sum_defects']);
        if (Number(this.reportType) === 0) {
          sum = sum.reduce((acc, data) => acc.concat(data));
        }

        sum = getSumOfValorFromArray(sum);

        let sumNet = this.rows.map((row) => row['net_weight_avg']);
        if (Number(this.reportType) === 0) {
          sumNet = sumNet.reduce((acc, data) => acc.concat(data));
        }

        sumNet = getSumOfValorFromArray(sumNet);

        let count = this.rows.map((row) => row['cluster']);
        if (Number(this.reportType) === 0) {
          count = count.reduce((acc, data) => acc.concat(data)).length;
        }

        return index === 'merma'
          ? Number((sum / sumNet) * 100)
          : Number((sumNet - sum) / (18.86 * count));
      }

      if (returnType === 1) {
        return (
          getSumOfValorFromArray(result) /
          result.filter((value) => value && Number(value) !== 0).length
        );
      }

      if (returnType === 2) {
        const max = Math.max(...result);
        return max;
      }

      if (returnType === 3) {
        const min = Math.min(...result);
        return min;
      }
    },

    fieldTotals(index, returnType) {
      const dataIndex = this.totals[index];
      let array = dataIndex ? dataIndex : [];

      if (index === 'ratio' || index === 'merma') {
        const sum = getSumOfValorFromArray(this.totals['sum_defects']);
        const sumNet = getSumOfValorFromArray(this.totals['net_weight_avg']);
        const count = this.totals['cluster'].length;

        return index === 'merma'
          ? Number((sum / sumNet) * 100)
          : Number((sumNet - sum) / (18.86 * count));
      }

      if (returnType === 1) {
        return (
          getSumOfValorFromArray(array) /
          array.filter((value) => value && Number(value) !== 0).length
        );
      }

      if (returnType === 2) {
        const max = Math.max(...array);
        return max;
      }

      if (returnType === 3) {
        const min = Math.min(...array);
        return min;
      }
    },
  },
};
</script>
